<!--<div class="overlay">-->
<!--  <img src="./assets/images/loader.gif">-->
<!--&lt;!&ndash;    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [value]="value">&ndash;&gt;-->
<!--&lt;!&ndash;    </mat-progress-spinner>&ndash;&gt;-->
<!--</div>-->

<div class="comments-loader">
  <img class="spinner" src="./assets/images/loader.gif">
</div>
